import { RootSchema } from "../../../redux/reducers";
import { AnalyticsEvent } from "../types";
import { mapStaticMutation } from "./helpers";

export const mapOrchestrationAnalyticsEvents = (previousState: RootSchema, currentState: RootSchema): AnalyticsEvent[] => [
  ...mapStaticMutation(previousState.workflow?.workflowMutations, currentState.workflow?.workflowMutations, {
    errorEventName: "orchestration_got_workflow_error",
    trackedEventNames: [
      "orchestration_created_workflow",
      "orchestration_updated_workflow",
      "orchestration_deleted_workflow",
      "orchestration_duplicated_workflow",
      "orchestration_downloaded_workflow",
      "orchestration_got_workflow_error"
    ]
  }),
  ...mapStaticMutation(previousState.workflow?.scriptMutations, currentState.workflow?.scriptMutations, {
    errorEventName: "orchestration_got_script_error",
    trackedEventNames: ["orchestration_created_script", "orchestration_updated_script", "orchestration_deleted_script", "orchestration_duplicated_script", "orchestration_got_script_error"]
  })
];
